class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");

      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  cartUpdateUnsubscriber = undefined;
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
        this.updateGifts();
      },
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
    );
  }

  onCartUpdate() {
    console.log('onCartUpdate');

    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          
          const currentSamplesSection = this.querySelector('.luminance_cart-samples');
          
          const sourceItems = html.querySelector('cart-drawer-items');
          if (sourceItems) {
            this.innerHTML = sourceItems.innerHTML;
          }
          
          const newSamplesSection = this.querySelector('.luminance_cart-samples');
          if (!newSamplesSection && currentSamplesSection) {
            this.appendChild(currentSamplesSection);
          }
          
          const targetFooter = document.querySelector('.cart-drawer__footer');
          const sourceFooter = html.querySelector('.cart-drawer__footer');
          if (targetFooter && sourceFooter) {
            targetFooter.innerHTML = sourceFooter.innerHTML;
          }

          if (typeof window.loadCartUpsellsSection === 'function') {
            setTimeout(() => {
              window.loadCartUpsellsSection();
            }, 100);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          const sourceQty = html.querySelector("cart-items");
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  updateGifts(totalStr = null) {
    const samples = document.querySelectorAll('cart-add-sample');
    if (samples.length === 0) return;
    
    // Aspetta se BOGOS sta processando
    if (window.FGSECOMAPP?.variables?.secomappGetCartRunning) {
      setTimeout(() => this.updateGifts(totalStr), 500);
      return;
    }
    
    // CORREZIONE: Converti la soglia in centesimi moltiplicando per 100
    const samplesMin = (parseInt(samples[0]?.dataset.min) || 0) * 100;

    const checkAndRemove = (totalInCents, cartItems = []) => {
      let samplesCount = 0;
      let sampleVariantsInCart = [];
      
      // Conta solo items con la property _is_sample
      cartItems.forEach(item => {
        const isSample = item.properties?._is_sample === 'true';
        
        if (isSample) {
          samplesCount++;
          sampleVariantsInCart.push(String(item.variant_id));
        }
      });

      const shouldRemoveSamples = totalInCents < samplesMin || samplesCount > 2;

      if (shouldRemoveSamples && sampleVariantsInCart.length > 0) {
        const formData = new FormData();
        
        sampleVariantsInCart.forEach(variantId => {
          formData.append(`updates[${variantId}]`, 0);
        });

        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(() => {
          const cartDrawerItems = document.querySelector('cart-drawer-items');
          if (cartDrawerItems) {
            cartDrawerItems.onCartUpdate();
          }
        });
      }
    };

    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        checkAndRemove(data.total_price, data.items);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0,
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector,
            ) || "";
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue,
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`),
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name"),
          );
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
        this.updateGifts();
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
      if (message.length > 0) lineItemError.style.display = "flex";
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;
    }

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      ?.querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`,
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`,
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden"),
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`,
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`,
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden"),
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({
              note: document.querySelector('[data-id="wt-cart-note"]').value,
            });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER),
        );
      }
    },
  );
}

class CartAddSample extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', async (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      
      // CORREZIONE: Converti la soglia in centesimi moltiplicando per 100
      const minValue = (parseInt(this.dataset.min) || 0) * 100;

      try {
        const cartData = await fetch('/cart.js').then(r => r.json());
        const items = cartData.items;
        const totalPrice = cartData.total_price; // Già in centesimi
        
        // Conta samples con la property _is_sample
        let samplesInCart = 0;
        let thisVariantInCart = false;
        
        items.forEach(item => {
          const isSample = item.properties?._is_sample === 'true';
          
          if (isSample) {
            samplesInCart++;
            
            if (item.variant_id == this.dataset.id) {
              thisVariantInCart = true;
            }
          }
        });

        if (thisVariantInCart) {
          // RIMUOVI
          await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              updates: { [this.dataset.id]: 0 }
            })
          });

          const modal = this.closest('.lcs_shademodal');
          if (modal) {
            modal.classList.remove('active');
            document.body.style.overflow = '';
          }
          
          cartItems.onCartUpdate();
          
        } else if (totalPrice >= minValue && samplesInCart < 2) {
          // AGGIUNGI con property
          await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: this.dataset.id,
                quantity: 1,
                properties: {
                  '_is_sample': 'true'
                }
              }]
            })
          });

          const modal = this.closest('.lcs_shademodal');
          if (modal) {
            modal.classList.remove('active');
            document.body.style.overflow = '';
          }
          
          cartItems.onCartUpdate();
        }

      } catch (error) {
        console.error('Error:', error);
      }
    });
  }
}

customElements.define('cart-add-sample', CartAddSample);

// Gestione modale con Event Delegation
document.addEventListener('click', function(e) {
  if (e.target.closest('.lcs_open_modal')) {
    e.preventDefault();
    const button = e.target.closest('.lcs_open_modal');
    const modal = button.nextElementSibling;
    if (modal && modal.classList.contains('lcs_shademodal')) {
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  if (e.target.closest('.lcs_modal_close')) {
    e.preventDefault();
    const modal = e.target.closest('.lcs_shademodal');
    if (modal) {
      modal.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  if (e.target.classList.contains('lcs_modal_overlay')) {
    const modal = e.target.closest('.lcs_shademodal');
    if (modal) {
      modal.classList.remove('active');
      document.body.style.overflow = '';
    }
  }
});